import { z } from "zod";

export namespace LoyaltyModels {
/** 
 * RewardSummaryDtoSchema 
 * @type { object }
 * @property { string } id Unique identifier of the reward. Example: `550e8400-e29b-41d4-a716-446655440000` 
 * @property { string } name Display name of the reward. Example: `Free Coffee Coupon` 
 * @property { string } description Description of the reward 
 * @property { number } threshold Points threshold required to unlock this reward. Minimum: `0`. Example: `500` 
 * @property { string } imageUrl URL of the reward image. Example: `https://example.com/images/reward.png` 
 * @property { string } unlockedImageUrl URL of the reward unlocked image. Example: `https://example.com/images/reward-unlocked.png` 
 * @property { string } unlockedAt  
 * @property { string } redeemCode Code for the redeem 
 * @property { string } redeemLink Link for the redeem 
 */
export const RewardSummaryDtoSchema = z.object({ id: z.string(), name: z.string(), description: z.string().nullish(), threshold: z.number().gte(0), imageUrl: z.string().nullish(), unlockedImageUrl: z.string().nullish(), unlockedAt: z.iso.datetime({ offset: true }).nullish(), redeemCode: z.string().nullish(), redeemLink: z.string().nullish() });
export type RewardSummaryDto = z.infer<typeof RewardSummaryDtoSchema>;


/** 
 * PointsSummarySchema 
 * @type { object }
 * @property { number } currentBalance Current points balance. Example: `750` 
 */
export const PointsSummarySchema = z.object({ currentBalance: z.number() });
export type PointsSummary = z.infer<typeof PointsSummarySchema>;


/** 
 * ListRewardsResponseSchema 
 * @type { array }
 */
export const ListRewardsResponseSchema = z.array(RewardSummaryDtoSchema);
export type ListRewardsResponse = z.infer<typeof ListRewardsResponseSchema>;


}
